import React, { useState } from "react";
import { useTranslation } from "react-i18next"; // <-- Importamos para traducciones
import {  AlertCircle,Check, X } from "lucide-react";
import "./SubscriptionView.css";

const SubscriptionView = () => {
  const [showContactDialog, setShowContactDialog] = useState(false);
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [notificationType, setNotificationType] = useState("");

  // Hook de traducción
  const { t } = useTranslation();

  const handleContactClick = () => {
    setShowContactDialog(true);
  };

  const handleSendContact = async () => {
    if (!email.trim() || !message.trim()) return;

    try {
      setLoading(true);
      // Simulamos un envío (2 segundos)
      await new Promise((resolve) => setTimeout(resolve, 2000));

      setNotificationType("success");
      setShowNotification(true);

      setTimeout(() => {
        setShowNotification(false);
        setShowContactDialog(false);
        setMessage("");
      }, 2000);
    } catch (error) {
      setNotificationType("error");
      setShowNotification(true);
      setTimeout(() => {
        setShowNotification(false);
      }, 2000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="subscription-view">
      <div className="subscription-header">
        <h1>{t("subscriptionView.header.title")}</h1>
        <p>{t("subscriptionView.header.subtitle")}</p>
      </div>

      <div className="subscription-main">
        <div className="current-subscription">
          <h2>{t("subscriptionView.currentSubscription.title")}</h2>
          <div className="subscription-info">
            <span className="plan">
              {t("subscriptionView.currentSubscription.plan")}
            </span>
            <span className="price">
              {t("subscriptionView.currentSubscription.price")}
            </span>
          </div>
        </div>

        <div className="change-plan">
          <h2>{t("subscriptionView.changePlan.title")}</h2>
          <div className="plans-container">
            {/* FREE Plan */}
            <div className="plan-card active">
              <div className="plan-details">
                <h3>{t("subscriptionView.changePlan.plans.free.name")}</h3>
                <p>{t("subscriptionView.changePlan.plans.free.coins")}</p>
                <span>{t("subscriptionView.changePlan.plans.free.price")}</span>
                <button>
                  {t("subscriptionView.changePlan.plans.free.button")}
                </button>
              </div>
            </div>

            {/* PROFESSIONAL Plan */}
            <div className="plan-card">
              <div className="plan-details">
                <h3>{t("subscriptionView.changePlan.plans.professional.name")}</h3>
                <p>{t("subscriptionView.changePlan.plans.professional.coins")}</p>
                <span>{t("subscriptionView.changePlan.plans.professional.price")}</span>
                <button>
                  {t("subscriptionView.changePlan.plans.professional.button")}
                </button>
              </div>
            </div>

            {/* ENTERPRISE Plan */}
            <div className="plan-card">
              <div className="plan-details">
                <h3>{t("subscriptionView.changePlan.plans.enterprise.name")}</h3>
                <p>{t("subscriptionView.changePlan.plans.enterprise.coins")}</p>
                <button onClick={handleContactClick}>
                  {t("subscriptionView.changePlan.plans.enterprise.button")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Dialog */}
      {showContactDialog && (
        <div className="contact-dialog-overlay">
          <div className="contact-dialog">
            <div className="contact-header">
              <h2>{t("subscriptionView.dialog.title")}</h2>
              <button
                className="close-button"
                onClick={() => {
                  setShowContactDialog(false);
                  setMessage("");
                }}
              >
                {/* Icono de cierre opcional */}
              </button>
            </div>

            <div className="contact-form">
              <div className="input-group">
                <label>{t("subscriptionView.dialog.fromLabel")}</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder={t("subscriptionView.dialog.placeholderEmail")}
                  className="email-input"
                />
              </div>

              <div className="input-group">
                <textarea
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder={t("subscriptionView.dialog.placeholderMessage")}
                  className="message-input"
                />
              </div>
            </div>

            <div className="dialog-actions">
              <button
                className="cancel-button"
                onClick={() => {
                  setShowContactDialog(false);
                  setMessage("");
                }}
                disabled={loading}
              >
                {t("subscriptionView.dialog.cancel")}
              </button>
              <button
                className="send-button"
                onClick={handleSendContact}
                disabled={loading || !message.trim() || !email.trim()}
              >
                {loading
                  ? t("subscriptionView.dialog.sending")
                  : t("subscriptionView.dialog.send")}
              </button>
            </div>

            {/* Notificación */}
            {showNotification && (
              <div className={`notification ${notificationType}`}>
                <div className="notification-content">
                  {notificationType === "success" ? (
                    <>
                      <Check size={32} className="notification-icon success" />
                      <span>{t("subscriptionView.dialog.sentSuccessfully")}</span>
                    </>
                  ) : (
                    <>
                      <AlertCircle size={32} className="notification-icon error" />
                      <span>{t("subscriptionView.dialog.somethingWentWrong")}</span>
                    </>
                  )}
                  <button onClick={() => setShowNotification(false)}>
                    <X size={24} />
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SubscriptionView;
